import { objectDuckCreator } from '@atc/modular-redux';

import { asfDuckPreset } from '@/ducks/presets/index.js';

const sfpContentDuck = objectDuckCreator({
    ...asfDuckPreset,
    store: 'content',
});

export default sfpContentDuck;
